import { render, staticRenderFns } from "./HorarioCRUD.vue?vue&type=template&id=3157af18"
import script from "./HorarioCRUD.vue?vue&type=script&lang=js"
export * from "./HorarioCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports